import { useSelector } from 'react-redux';
import Global from '../../../../../../store/global-selectors';

/**
 * If the promotion upgrade slice of Redux doesn't have this value then there is available no offer
 * @constant {string}
 */
const PromotionalOfferProperty = 'targetBillingPlan';

/**
 * Returns whether or not the user has an available promotional plan migration offer.
 * Returns false if the offer has already been accepted.
 * @returns {boolean}
 */
export const useDoesSellerHavePromotionalOffer = () =>
  useSelector((state) => {
    const promotionUpgrade = Global.selectSellerPromotionUpgrade(state) || {};
    return PromotionalOfferProperty in promotionUpgrade && !promotionUpgrade.isAccepted;
  });
